function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspirationSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#236A8D",
    d: "M 502.292 781.98 C 531.124 820.848 551.839 865.122 563.204 912.163 L 577.536 977.852 L 578.73 981.435 L 363.748 981.435 L 350.611 980.24 L 349.416 974.269 L 343.445 946.799 L 344.639 944.41 L 343.445 944.41 L 342.25 946.799 L 338.667 937.244 L 342.25 933.661 L 335.084 925.301 L 325.529 891.859 L 317.169 926.495 L 312.392 927.689 C 311.197 931.272 310.003 936.05 311.197 939.633 C 309.338 953.257 306.948 966.803 304.031 980.24 L 299.254 981.435 L 202.512 981.435 L 166.682 982.629 L 93.827 981.435 L 38.887 981.435 C 30.527 981.435 22.167 975.463 22.167 967.103 L 20.972 910.969 L 19.778 882.304 L 19.778 798.7 L 20.972 765.259 C 22.167 752.121 23.361 737.789 26.944 725.846 C 31.721 710.319 38.887 695.987 48.442 682.849 C 62.774 661.351 80.689 645.825 103.382 635.076 L 117.714 627.91 C 122.491 626.715 126.074 624.326 124.88 618.355 L 128.463 620.743 L 140.407 625.521 L 141.601 625.521 L 172.654 627.91 C 197.735 629.104 221.622 636.27 246.703 641.047 L 282.533 647.019 L 282.533 648.213 L 296.865 651.796 L 310.003 657.768 L 321.946 658.962 C 324.335 658.962 327.918 661.351 330.307 660.157 C 335.084 660.157 337.473 656.574 341.056 655.379 L 341.056 664.934 C 341.056 666.128 342.25 668.517 344.639 668.517 L 366.137 678.072 L 428.243 715.096 C 440.186 722.263 452.13 731.817 462.879 741.372 L 499.903 778.397 L 501.098 779.591 L 502.292 781.98 M 342.25 940.827 C 342.25 940.827 342.25 942.021 342.25 940.827 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#357FA1",
    d: "M 341.056 655.379 C 337.473 656.574 335.084 660.157 330.307 660.157 C 327.918 661.351 324.335 658.962 321.946 658.962 L 310.003 657.768 L 296.865 651.796 L 282.533 648.213 L 282.533 647.019 L 246.703 641.047 C 221.622 636.27 197.735 629.104 172.654 627.91 L 141.601 625.521 L 140.407 625.521 L 128.463 620.743 L 126.074 618.355 L 128.463 596.857 L 132.046 566.998 L 135.629 534.751 L 142.795 534.751 L 140.407 539.528 L 152.35 537.14 L 151.156 543.111 L 152.35 544.306 L 153.544 537.14 L 167.876 547.889 L 161.905 553.86 L 161.905 549.083 L 154.739 550.277 L 151.156 547.889 L 143.99 551.472 L 141.601 555.055 L 145.184 558.638 L 146.378 555.055 L 167.876 556.249 C 170.265 557.443 171.459 562.221 173.848 559.832 L 172.654 549.083 L 181.014 553.86 L 182.208 555.055 L 183.403 552.666 C 191.763 549.083 191.763 547.889 188.18 540.723 L 184.597 543.111 L 184.597 541.917 C 181.014 539.528 175.042 541.917 176.237 534.751 L 181.014 533.557 L 184.597 534.751 L 184.597 528.779 C 215.65 516.836 235.954 491.755 256.258 469.062 L 269.395 475.034 C 282.533 486.977 301.643 488.172 310.003 464.285 L 301.643 463.09 C 293.282 461.896 283.728 463.09 275.367 457.119 L 272.978 457.119 C 259.137 445.065 249.86 428.62 246.703 410.539 C 243.12 389.041 244.314 368.737 261.035 353.211 C 270.59 343.656 287.311 341.267 299.254 348.434 C 308.809 353.211 317.169 360.377 326.724 366.349 C 327.918 367.543 331.501 368.737 332.696 367.543 L 349.416 347.239 C 356.582 334.101 358.971 318.575 358.971 304.243 L 356.582 255.275 C 356.582 249.303 360.165 245.72 366.137 244.526 C 380.469 242.137 393.607 237.36 406.745 230.194 L 424.66 219.445 C 435.409 236.165 444.964 254.081 450.935 274.384 C 453.324 286.328 452.13 298.271 449.741 310.215 C 447.352 322.158 449.741 334.101 456.907 344.851 L 478.405 374.709 L 499.903 410.539 C 508.264 427.26 504.681 436.815 486.766 443.981 L 472.434 448.758 L 466.462 448.758 L 464.073 452.341 C 464.073 476.228 461.684 498.921 458.101 521.613 C 454.518 539.528 452.13 557.443 441.381 572.97 L 438.992 575.358 C 431.826 581.33 424.66 584.913 415.105 586.108 L 409.133 587.302 L 344.639 586.108 L 344.639 619.549 L 341.056 655.379 M 386.441 262.441 L 387.635 261.247 L 391.218 255.275 L 385.247 255.275 L 373.303 262.441 L 375.692 269.607 L 376.886 274.384 C 373.303 277.967 375.692 279.162 379.275 281.55 L 378.081 269.607 C 379.275 266.024 380.469 262.441 386.441 262.441 M 373.303 280.356 L 372.109 280.356 L 372.109 281.55 L 375.692 287.522 L 369.72 286.328 L 373.303 288.716 L 367.331 292.299 L 368.526 293.494 L 379.275 292.299 C 379.275 287.522 380.469 282.745 373.303 280.356 M 373.303 304.243 C 380.469 309.02 375.692 297.077 381.664 298.271 L 380.469 294.688 L 378.081 294.688 L 372.109 297.077 L 373.303 304.243 M 370.914 305.437 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C4F6C",
    d: "M 73.523 446.37 L 75.912 441.592 L 73.523 445.175 L 59.191 416.511 L 46.054 375.903 C 43.665 363.96 43.665 352.017 43.665 340.073 C 42.47 325.741 42.47 310.215 44.859 295.882 C 47.248 266.024 55.608 238.554 71.135 214.667 C 83.078 197.946 93.827 181.226 108.159 166.894 C 126.074 151.367 143.99 134.646 165.488 123.897 C 198.509 106.79 234.685 96.629 271.784 94.039 L 324.335 92.844 L 326.724 94.039 L 349.416 95.233 L 378.081 100.01 C 395.996 104.788 412.716 113.148 427.049 125.092 L 441.381 141.812 L 437.798 144.201 L 434.215 141.812 L 437.798 144.201 L 441.381 141.812 L 441.381 143.007 L 443.769 144.201 L 443.769 145.395 L 444.964 146.59 L 446.158 148.978 C 454.518 168.088 450.935 184.809 440.186 200.335 L 423.466 219.445 L 406.745 230.194 C 393.607 237.36 380.469 242.137 366.137 244.526 C 360.165 245.72 356.582 249.303 356.582 255.275 L 358.971 304.243 C 358.971 318.575 356.582 334.101 349.416 347.239 L 332.696 367.543 C 331.501 368.737 327.918 367.543 326.724 366.349 C 317.169 360.377 308.809 353.211 299.254 348.434 C 287.311 341.267 270.59 343.656 261.035 353.211 C 244.314 368.737 243.12 389.041 246.703 410.539 C 249.092 428.454 258.646 443.981 271.784 457.119 C 269.395 461.896 271.784 464.285 275.367 466.673 L 278.95 471.451 L 269.395 475.034 L 256.258 469.062 C 235.954 491.755 215.65 516.836 184.597 528.779 L 171.459 533.557 L 142.795 534.751 L 135.629 534.751 L 132.046 531.168 L 136.823 515.641 C 136.823 510.864 140.407 504.892 133.24 502.504 L 117.714 492.949 C 114.131 491.755 110.548 489.366 108.159 492.949 L 103.382 492.949 L 97.41 490.56 L 74.718 447.564 L 73.523 446.37 Z M 75.912 432.037 L 74.718 432.037 L 75.912 432.037 L 77.106 439.204 L 75.912 432.037 Z M 77.106 428.454 Z M 72.329 418.9 Z M 73.523 377.098 Z M 83.078 398.596 Z M 84.272 404.568 C 84.272 409.345 83.078 414.122 87.855 417.705 L 87.855 418.9 L 87.855 417.705 C 83.078 414.122 84.272 409.345 84.272 404.568 L 84.272 403.373 L 84.272 404.568 Z M 90.244 423.677 Z M 104.576 429.649 Z M 111.742 429.649 L 124.88 426.066 L 111.742 429.649 Z M 138.018 430.843 Z M 157.127 445.175 L 164.293 436.815 L 172.654 424.871 C 176.237 420.094 173.848 417.705 167.876 417.705 L 135.629 417.705 C 132.046 417.705 130.852 416.511 130.852 412.928 C 130.852 416.511 132.046 417.705 135.629 417.705 L 167.876 417.705 C 173.848 417.705 176.237 420.094 172.654 424.871 L 164.293 436.815 L 157.127 445.175 L 151.156 440.398 L 157.127 445.175 Z M 136.823 398.596 L 138.018 396.207 L 136.823 398.596 Z M 161.905 374.709 L 166.682 367.543 L 161.905 374.709 C 157.127 380.681 147.573 379.486 142.795 386.652 C 147.573 379.486 157.127 380.681 161.905 374.709 Z M 175.042 360.377 C 178.625 360.377 181.014 357.988 183.403 355.6 C 181.014 357.988 178.625 360.377 175.042 360.377 L 171.459 361.571 L 175.042 360.377 Z M 184.597 349.628 Z M 237.148 317.381 Z M 283.728 305.437 Z M 286.116 304.243 C 292.088 295.882 299.254 288.716 304.031 279.162 C 308.809 270.801 314.78 260.052 307.614 249.303 C 314.78 260.052 308.809 270.801 304.031 279.162 C 299.254 288.716 292.088 295.882 286.116 304.243 Z M 308.809 246.914 C 311.197 245.72 315.975 245.72 315.975 238.554 C 315.975 234.971 319.558 231.388 323.141 227.805 C 319.558 231.388 315.975 234.971 315.975 238.554 C 315.975 245.72 311.197 245.72 308.809 246.914 L 307.614 248.109 L 308.809 246.914 Z M 318.363 208.696 Z M 312.392 206.307 L 313.586 206.307 L 312.392 206.307 Z M 314.78 188.392 L 311.197 180.031 L 312.392 175.254 L 317.169 166.894 L 312.392 175.254 L 311.197 180.031 L 314.78 188.392 L 311.197 189.586 L 314.78 188.392 Z M 355.388 172.865 C 366.137 175.254 375.692 174.06 386.441 172.865 C 375.692 174.06 366.137 175.254 355.388 172.865 Z M 390.024 172.865 L 385.247 166.894 L 390.024 172.865 Z M 390.024 164.505 L 390.024 163.311 L 390.024 164.505 Z M 388.83 156.145 L 384.052 153.756 L 388.83 156.145 Z M 376.886 138.229 C 375.692 134.646 379.275 126.286 382.858 125.092 L 384.052 125.092 L 382.858 125.092 C 379.275 126.286 375.692 134.646 376.886 138.229 Z M 385.247 125.092 C 393.607 119.12 399.579 122.703 406.745 126.286 C 399.579 122.703 393.607 119.12 385.247 125.092 Z M 319.558 201.529 L 321.946 203.918 L 323.141 202.724 L 319.558 201.529 Z M 171.459 365.154 L 170.265 366.349 L 170.265 367.543 L 171.459 365.154 Z M 73.523 432.037 Z M 138.018 395.013 L 138.018 392.624 L 138.018 395.013 Z M 216.844 332.907 Z M 240.731 313.798 Z M 241.926 310.215 C 244.314 306.632 247.897 305.437 252.675 305.437 C 247.897 305.437 244.314 306.632 241.926 310.215 Z M 327.918 214.667 Z M 388.83 163.311 L 386.441 160.922 L 388.83 163.311 Z M 427.049 135.841 L 427.049 138.229 L 427.049 135.841 Z M 299.254 981.435 L 304.031 980.24 L 314.78 980.24 L 315.975 979.046 L 311.197 973.074 C 312.392 971.88 315.975 969.491 314.78 968.297 C 314.78 961.131 317.169 955.159 320.752 949.187 L 326.724 934.855 C 329.113 940.827 336.279 944.41 332.696 951.576 C 337.473 951.576 336.279 955.159 337.473 957.548 L 341.056 974.269 L 345.833 974.269 L 339.862 980.24 L 351.805 980.24 L 363.748 981.435 C 342.258 982.255 320.744 982.255 299.254 981.435 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#194B67",
    d: "M 97.41 491.755 L 103.382 492.949 L 108.159 492.949 C 110.548 489.366 114.131 491.755 117.714 492.949 L 133.24 502.504 C 140.407 504.892 136.823 510.864 136.823 515.641 L 132.046 529.973 L 110.548 509.67 L 97.41 491.755 Z M 73.523 446.37 L 74.718 447.564 L 73.523 446.37 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#357FA1",
    d: "M 962.118 307.826 L 981.228 305.437 L 985.998 306.632 C 996.75 304.243 1001.53 307.826 1005.11 317.381 C 1005.11 330.518 997.95 334.101 987.198 334.101 L 966.888 334.101 L 932.255 331.713 L 925.089 326.935 C 920.312 322.158 923.895 311.409 929.866 310.215 L 941.81 307.826 L 962.118 307.826 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AC7D1",
    d: "M 513.041 767.647 L 511.847 767.647 L 514.235 766.453 L 513.041 767.647 Z M 502.292 780.785 L 501.098 779.591 L 502.292 780.785 Z M 503.486 756.898 L 503.486 758.093 L 502.292 758.093 L 503.486 756.898 Z M 975.248 509.67 L 975.248 508.475 L 975.248 509.67 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F5776",
    d: "M 350.611 980.24 L 339.862 980.24 L 345.833 974.269 L 341.056 974.269 L 337.473 957.548 C 336.279 955.159 337.473 951.576 332.696 951.576 C 336.279 944.41 329.113 940.827 326.724 934.855 L 320.752 949.187 C 317.169 955.159 314.78 961.131 314.78 968.297 C 315.975 969.491 312.392 971.88 311.197 973.074 L 315.975 979.046 L 314.78 980.24 L 305.226 980.24 L 311.197 950.382 C 312.392 946.799 313.586 943.216 311.197 939.633 C 310.003 936.05 311.197 931.272 312.392 927.689 L 317.169 926.495 L 325.529 891.859 L 335.084 925.301 L 342.25 933.661 L 338.667 937.244 L 342.25 946.799 L 343.445 946.799 L 349.416 974.269 L 350.611 980.24 M 335.084 943.216 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F5776",
    d: "M 344.639 944.41 L 343.445 946.799 L 343.445 944.41 L 344.639 944.41 Z M 342.25 940.827 C 342.25 942.021 342.25 940.827 342.25 940.827 Z M 344.639 944.41 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4287A7",
    d: "M 142.795 534.751 L 171.459 533.557 L 184.597 529.973 L 184.597 534.751 L 181.014 533.557 L 176.237 534.751 C 175.042 541.917 181.014 539.528 184.597 541.917 L 181.014 544.306 L 182.208 545.5 L 184.597 543.111 L 188.18 540.723 C 191.763 547.889 191.763 549.083 183.403 552.666 L 181.014 552.666 L 172.654 549.083 L 173.848 559.832 C 171.459 562.221 170.265 557.443 167.876 556.249 L 146.378 555.055 L 145.184 558.638 L 141.601 555.055 L 143.99 551.472 L 151.156 547.889 L 154.739 550.277 L 161.905 549.083 L 161.905 553.86 L 167.876 547.889 L 153.544 537.14 L 152.35 544.306 L 151.156 543.111 L 152.35 537.14 L 140.407 539.528 L 142.795 534.751 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F5776",
    d: "M 269.395 475.034 L 278.95 471.451 L 275.367 466.673 C 271.784 464.285 269.395 461.896 272.978 457.119 L 275.367 457.119 C 283.728 463.09 293.282 461.896 301.643 463.09 L 310.003 464.285 C 301.643 488.172 282.533 486.977 269.395 475.034 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4287A7",
    d: "M 385.247 262.441 C 380.469 262.441 379.275 266.024 378.081 269.607 L 379.275 281.55 C 375.692 279.162 373.303 277.967 376.886 274.384 L 375.692 269.607 L 373.303 262.441 L 385.247 255.275 L 391.218 255.275 L 387.635 261.247 L 385.247 262.441 Z M 373.303 280.356 C 380.469 282.745 379.275 287.522 379.275 292.299 L 368.526 293.494 L 367.331 292.299 L 373.303 288.716 L 369.72 286.328 L 375.692 287.522 L 372.109 281.55 L 372.109 280.356 L 373.303 280.356 Z M 373.303 304.243 L 372.109 297.077 L 378.081 294.688 L 380.469 294.688 L 381.664 298.271 C 375.692 297.077 380.469 309.02 373.303 304.243 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBD3D6",
    d: "M 470.045 448.758 L 467.656 448.758 L 470.045 448.758 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4287A7",
    d: "M 182.208 552.666 L 182.208 555.055 L 181.014 553.86 L 182.208 552.666 Z M 370.914 305.437 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#194B67",
    d: "M 319.558 200.335 L 323.141 202.724 L 321.946 203.918 L 319.558 200.335 Z M 171.459 366.349 L 170.265 367.543 L 170.265 366.349 L 171.459 366.349 Z M 441.381 143.007 L 443.769 144.201 L 441.381 143.007 Z M 443.769 145.395 L 444.964 146.59 L 443.769 145.395 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#357FA1",
    d: "M 877.315 470.256 L 922.7 514.447 C 926.283 519.224 925.089 525.196 922.7 529.973 C 920.312 534.751 915.534 537.14 910.757 534.751 C 907.174 534.751 904.785 531.168 901.202 528.779 L 891.647 519.224 L 890.453 518.03 L 864.178 490.56 C 859.4 485.783 858.206 481.005 860.595 476.228 C 862.983 470.256 867.761 469.062 872.538 470.256 L 877.315 470.256 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C4F6C",
    d: "M 658.751 660.157 L 659.945 656.574 L 670.694 658.962 L 670.694 656.574 L 671.889 656.574 L 674.277 663.74 L 681.443 663.74 C 686.221 664.934 689.804 668.517 695.775 664.934 L 700.553 667.323 L 705.33 668.517 L 724.44 666.128 C 729.217 666.128 732.8 663.74 736.383 662.545 C 741.16 661.351 747.132 656.574 750.715 657.768 C 756.687 660.157 761.464 658.962 767.436 657.768 C 763.853 667.323 756.687 674.489 749.521 680.461 L 748.326 680.461 L 745.938 681.655 C 735.189 686.432 724.44 690.015 712.496 688.821 C 694.581 687.627 679.055 684.044 667.111 669.711 C 664.723 668.517 663.528 666.128 662.334 662.545 L 659.945 661.351 C 659.945 661.351 659.945 662.545 659.945 661.351 C 659.579 660.922 659.18 660.523 658.751 660.157 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8EC4D0",
    d: "M 959.728 507.281 L 956.142 508.475 L 954.948 506.087 L 959.728 507.281 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8CBD3",
    d: "M 602.617 694.793 L 605.005 693.598 L 605.005 694.793 L 602.617 694.793 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9CCD3",
    d: "M 386.441 594.468 L 385.247 592.079 L 386.441 592.079 L 386.441 594.468 Z M 900.008 552.666 L 900.008 551.472 L 901.202 551.472 L 900.008 552.666 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8CBD3",
    d: "M 659.945 662.545 L 661.14 662.545 L 659.945 662.545 Z M 658.751 660.157 L 659.945 661.351 L 658.751 660.157 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9CCD3",
    d: "M 395.996 598.051 L 397.19 598.051 L 395.996 598.051 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8EC4D0",
    d: "M 962.118 494.143 C 962.508 494.544 962.908 494.942 963.308 495.338 L 962.118 494.143 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9CCD3",
    d: "M 900.008 537.14 C 900.008 537.14 901.202 537.14 900.008 537.14 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8EC4D0",
    d: "M 504.681 771.231 L 504.681 770.036 L 504.681 771.231 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9CCD3",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8CBD3",
    d: "M 646.807 668.517 Z M 597.839 691.21 Z M 642.03 684.044 L 642.03 685.238 L 642.03 684.044 Z M 599.034 685.238 Z M 607.394 682.849 Z M 601.422 681.655 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2C9D2",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8CBD3",
    d: "M 602.617 692.404 C 602.617 691.21 602.617 692.404 602.617 692.404 Z M 599.034 693.598 Z M 642.03 676.878 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8EC4D0",
    d: "M 995.56 349.628 Z M 948.976 534.751 Z M 962.118 509.67 C 962.118 509.67 962.118 508.475 962.118 509.67 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9CCD3",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#357FA1",
    d: "M 698.164 96.427 L 698.164 89.261 L 699.358 58.208 L 699.358 51.042 L 700.553 36.71 C 701.747 31.933 707.719 28.35 713.691 28.35 C 719.662 28.35 723.245 33.127 723.245 39.099 L 724.44 42.682 L 724.44 103.593 C 724.44 108.371 719.662 114.343 714.885 115.537 C 708.913 115.537 700.553 111.954 699.358 107.176 L 698.164 96.427 Z M 538.122 114.343 L 567.981 144.201 L 572.758 152.561 L 570.37 165.699 C 560.815 168.088 552.454 166.894 545.288 158.533 L 513.041 127.48 L 510.652 123.897 C 504.681 116.731 505.875 109.565 513.041 104.788 C 516.624 100.01 524.985 101.205 529.762 105.982 L 538.122 114.343 Z M 897.619 141.812 L 874.927 163.311 C 868.955 169.282 859.4 168.088 853.429 162.116 C 849.846 156.145 851.04 148.978 857.012 143.007 L 878.51 123.897 L 898.814 103.593 L 909.563 102.399 L 917.923 115.537 L 915.534 122.703 L 915.534 123.897 L 897.619 141.812 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD2D6",
    d: "M 811.627 85.678 L 814.015 84.484 L 814.015 85.678 L 811.627 85.678 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96C6D1",
    d: "M 524.985 94.039 L 526.179 94.039 L 526.179 95.233 L 524.985 94.039 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD2D6",
    d: "M 534.539 98.816 L 534.539 100.01 L 533.345 98.816 L 534.539 98.816 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBD3D6",
    d: "M 513.041 227.805 L 510.652 228.999 C 511.45 228.603 512.246 228.205 513.041 227.805 Z M 510.652 240.943 C 510.652 239.748 510.652 240.943 510.652 240.943 Z M 501.098 249.303 Z M 486.766 267.218 C 486.766 267.218 486.766 266.024 486.766 267.218 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD2D6",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96C6D1",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD2D6",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AACCD3",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C4F6C",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#357FA1",
    d: "M 862.983 242.137 L 874.927 274.384 C 879.704 291.105 879.704 307.826 879.704 324.547 C 879.704 342.462 877.315 360.377 872.538 377.098 C 866.566 396.207 857.012 412.928 845.068 428.454 L 841.485 433.232 L 837.902 436.815 L 835.513 439.204 L 830.736 446.37 L 817.598 469.062 L 816.404 469.062 L 814.015 473.839 L 805.655 500.115 L 803.266 529.973 L 799.683 531.168 L 774.602 529.973 L 775.796 521.613 C 776.991 512.058 776.991 501.309 779.379 491.755 C 781.768 478.617 786.545 467.868 791.323 455.924 L 792.517 454.73 L 792.517 453.536 L 793.711 452.341 L 794.906 451.147 L 796.1 446.37 L 797.294 446.37 L 804.461 436.815 L 817.598 421.288 C 833.125 405.762 843.874 386.652 848.651 366.349 C 854.623 342.462 857.012 318.575 852.234 294.688 C 847.457 264.83 835.513 239.748 814.015 218.25 C 796.1 199.141 773.408 186.003 747.132 180.031 C 725.634 175.254 702.941 174.06 681.443 178.837 C 608.896 195.493 561.488 265.302 572.758 338.879 C 575.147 366.349 585.896 391.43 603.811 414.122 L 633.67 452.341 C 644.419 469.062 648.002 488.172 650.39 508.475 L 650.39 526.39 C 648.002 528.779 648.002 531.168 644.419 531.168 C 637.253 529.973 630.087 528.779 624.115 531.168 L 622.921 531.168 L 622.921 519.224 L 619.338 489.366 C 616.949 477.422 612.172 467.868 606.2 458.313 L 593.062 441.592 L 590.673 436.815 C 582.313 424.871 572.758 414.122 565.592 402.179 C 556.037 386.652 551.26 369.932 547.677 352.017 L 545.288 317.381 C 545.288 285.133 554.843 256.469 571.564 228.999 L 576.341 223.028 C 593.062 199.141 615.755 178.837 643.224 165.699 C 708.034 135.576 784.824 149.974 834.319 201.529 L 848.651 218.25 L 859.4 234.971 L 862.983 242.137 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#205978",
    d: "M 622.921 531.168 L 624.115 531.168 C 630.087 528.779 637.253 529.973 644.419 531.168 C 648.002 531.168 648.002 528.779 650.39 526.39 L 650.39 529.973 L 651.585 531.168 L 695.775 531.168 L 700.553 528.779 L 722.051 531.168 L 722.051 529.973 L 718.468 527.585 L 724.44 524.002 L 724.44 527.585 C 724.44 532.362 726.828 532.362 729.217 532.362 L 774.602 531.168 L 799.683 531.168 L 803.266 529.973 C 808.044 539.528 806.849 551.472 808.044 562.221 L 806.849 570.581 L 805.655 570.581 L 793.711 568.192 L 791.323 566.998 L 722.051 566.998 L 716.079 568.192 L 652.779 568.192 L 620.532 566.998 L 619.338 565.804 L 622.921 531.168 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCDAD9",
    d: "M 560.815 184.809 L 558.426 183.614 L 559.62 182.42 L 560.815 184.809 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AACCD3",
    d: "M 493.932 270.801 L 495.126 269.607 L 496.32 269.607 L 493.932 270.801 Z M 524.985 197.946 L 524.985 196.752 L 526.179 196.752 L 524.985 197.946 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCDAD9",
    d: "M 593.062 467.868 L 591.868 469.062 L 591.868 467.868 L 593.062 467.868 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#205978",
    d: "M 622.921 527.585 L 622.921 528.779 L 622.921 527.585 Z M 622.921 525.196 L 622.921 526.39 L 622.921 525.196 Z M 622.921 522.807 L 622.921 524.002 L 622.921 522.807 Z M 622.921 520.419 L 622.921 521.613 L 622.921 520.419 Z M 622.921 519.224 L 622.921 520.419 L 622.921 519.224 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8CBD3",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCDAD9",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AACCD3",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8CBD3",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#347EA0",
    d: "M 790.128 637.464 L 771.019 639.853 C 760.27 638.659 750.715 637.464 739.966 639.853 L 739.966 637.464 C 739.567 637.067 739.169 636.669 738.772 636.27 L 735.189 638.659 L 683.832 639.853 L 679.055 637.464 L 675.472 638.659 L 656.362 638.659 C 648.002 639.853 639.641 637.464 632.475 632.687 C 624.115 626.715 620.532 618.355 621.726 608.8 L 694.581 607.606 L 779.379 608.8 L 790.128 611.189 L 791.323 608.8 C 792.648 610.29 793.846 611.888 794.906 613.577 L 796.1 612.383 L 793.711 611.189 L 804.461 607.606 L 806.849 615.966 L 802.072 631.493 L 790.128 637.464 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#205978",
    d: "M 806.849 615.966 L 804.461 607.606 L 793.711 611.189 L 791.323 608.8 L 790.128 611.189 L 779.379 608.8 L 694.581 607.606 L 621.726 607.606 L 620.532 584.913 L 661.14 584.913 C 667.109 584.907 673.085 584.907 679.055 584.913 L 692.192 586.108 L 723.245 584.913 L 778.185 586.108 L 808.044 586.108 L 806.849 615.966 Z M 656.362 638.659 L 675.472 638.659 L 679.055 637.464 L 683.832 639.853 L 735.189 638.659 L 738.772 636.27 L 743.549 636.27 L 739.966 637.464 L 739.966 639.853 C 750.715 637.464 760.27 638.659 769.825 639.853 L 767.436 656.574 C 761.464 658.962 756.687 660.157 750.715 657.768 C 747.132 656.574 741.16 661.351 736.383 662.545 C 732.8 663.74 729.217 666.128 724.44 666.128 L 705.33 668.517 L 700.553 667.323 L 695.775 664.934 C 689.804 668.517 686.221 664.934 681.443 663.74 L 674.277 663.74 L 671.889 656.574 L 670.694 656.574 L 670.694 658.962 L 659.945 656.574 C 656.362 650.602 655.168 645.825 656.362 638.659 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#276F92",
    d: "M 624.115 584.913 L 620.532 584.913 L 620.532 568.192 L 652.779 568.192 C 656.362 570.581 658.751 572.97 655.168 576.553 L 646.807 571.775 L 650.39 577.747 L 643.224 582.525 L 640.836 578.941 L 640.836 584.913 L 634.864 578.941 L 634.864 582.525 C 631.281 581.33 625.309 586.108 626.504 577.747 C 620.532 578.941 625.309 582.525 624.115 584.913 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AC7D1",
    d: "M 606.2 666.128 L 605.005 663.74 L 607.394 663.74 L 606.2 666.128 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD2D6",
    d: "M 490.349 464.285 L 487.96 463.09 L 487.96 461.896 L 490.349 464.285 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBD3D6",
    d: "M 526.179 485.783 L 527.373 483.394 L 528.568 486.977 L 526.179 485.783 Z M 548.871 494.143 L 548.871 496.532 L 547.677 496.532 L 548.871 494.143 Z M 572.758 510.864 L 571.564 513.253 L 570.37 512.058 L 572.758 510.864 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96C6D1",
    d: "M 650.39 651.796 L 649.196 651.796 L 650.39 651.796 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AC7D1",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96C6D1",
    d: "M 656.362 657.768 C 657.557 657.768 656.362 657.768 656.362 657.768 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AC7D1",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96C6D1",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBD3D6",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD2D6",
    d: "M 501.098 478.617 Z M 498.709 477.422 C 498.709 477.422 497.515 477.422 498.709 477.422 Z M 502.292 476.228 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AC7D1",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD2D6",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBD3D6",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#357FA1",
    d: "M 184.597 543.111 L 182.208 545.5 L 181.014 544.306 L 184.597 543.111 Z M 182.208 552.666 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30799C",
    d: "M 808.044 586.108 L 778.185 586.108 L 723.245 584.913 L 692.192 586.108 L 680.249 584.913 C 687.415 583.719 687.415 577.747 687.415 571.775 L 689.804 576.553 L 695.775 571.775 L 698.164 577.747 C 704.136 575.358 707.719 577.747 712.496 581.33 L 712.496 572.97 L 705.33 572.97 L 706.525 571.775 L 705.33 568.192 L 714.885 568.192 L 716.079 569.387 L 716.079 568.192 L 722.051 566.998 L 791.323 566.998 L 793.711 568.192 L 799.683 574.164 L 794.906 571.775 L 790.128 575.358 L 790.128 576.553 L 793.711 575.358 L 794.906 581.33 L 799.683 574.164 C 803.266 575.358 805.655 574.164 805.655 570.581 L 806.849 570.581 L 806.849 578.941 L 808.044 581.33 L 808.044 586.108 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AC7D1",
    d: "M 894.036 533.557 L 894.036 534.751 L 894.036 532.362 L 894.036 533.557 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD2D6",
    d: "M 808.044 586.108 L 808.044 584.913 L 811.627 584.913 L 808.044 586.108 Z M 845.068 512.058 L 845.068 510.864 L 845.068 512.058 Z M 808.044 582.525 L 806.849 581.33 L 808.044 582.525 Z M 842.679 509.67 Z M 808.044 584.913 L 808.044 583.719 L 808.044 584.913 Z M 890.453 518.03 L 891.647 519.224 L 890.453 518.03 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AC7D1",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD2D6",
    d: "M 928.672 344.851 C 928.672 344.851 929.866 344.851 928.672 344.851 Z M 932.255 340.073 Z M 931.061 337.684 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AC7D1",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9CCD3",
    d: "M 870.149 459.507 L 868.955 463.09 L 867.761 461.896 L 870.149 459.507 Z M 868.955 465.479 L 867.761 467.868 L 866.566 466.673 L 868.955 465.479 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCDAD9",
    d: "M 849.846 212.279 L 849.846 209.89 L 851.04 209.89 L 849.846 212.279 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AACCD3",
    d: "M 821.181 98.816 L 819.987 98.816 L 819.987 97.622 L 821.181 98.816 Z M 935.838 306.632 L 934.644 306.632 C 934.644 306.632 934.644 305.437 934.644 306.632 L 935.838 306.632 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9CCD3",
    d: "M 829.542 510.864 L 830.736 510.864 L 829.542 510.864 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCDAD9",
    d: "M 837.902 451.147 L 837.902 452.341 L 837.902 451.147 Z M 810.432 163.311 Z M 731.606 77.318 L 731.606 76.124 L 731.606 77.318 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AACCD3",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCDAD9",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AACCD3",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCDAD9",
    d: "M 810.432 160.922 Z M 780.574 140.618 L 781.768 140.618 L 780.574 140.618 Z M 792.517 135.841 L 793.711 137.035 L 792.517 135.841 Z M 792.517 135.841 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9CCD3",
    d: "M 824.764 514.447 C 824.764 514.447 824.764 515.641 824.764 514.447 Z M 827.153 513.253 Z M 867.761 457.119 C 866.566 457.119 867.761 457.119 867.761 457.119 Z M 868.955 454.73 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCDAD9",
    d: "M 689.804 95.233 L 690.998 95.233 L 690.998 96.427 L 689.804 95.233 Z M 661.14 120.314 L 662.334 119.12 L 662.334 120.314 L 661.14 120.314 Z M 625.309 140.618 L 626.504 140.618 L 625.309 140.618 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AACCD3",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCDAD9",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFDBDA",
    d: "M 700.553 528.779 L 695.775 531.168 C 680.639 531.2 665.504 530.801 650.39 529.973 L 650.39 508.475 C 648.002 488.172 644.419 469.062 633.67 452.341 L 603.811 414.122 C 571.786 372.689 562.805 317.903 579.924 268.413 C 585.896 252.886 593.062 238.554 605.005 226.611 C 639.72 185.397 694.757 167.359 747.132 180.031 C 773.408 186.003 796.1 199.141 814.015 218.25 C 835.513 239.748 847.457 264.83 852.234 294.688 C 857.012 318.575 854.623 342.462 848.651 366.349 C 843.874 386.652 833.125 405.762 817.598 421.288 L 819.987 416.511 C 822.376 411.734 822.376 411.734 817.598 410.539 L 817.598 409.345 L 814.015 405.762 C 814.015 411.734 812.821 412.928 808.044 410.539 C 805.655 409.345 800.878 412.928 799.683 416.511 L 797.294 422.483 L 804.461 422.483 L 793.711 436.815 L 796.1 439.204 L 803.266 430.843 L 804.461 436.815 L 797.294 446.37 C 796.1 438.009 788.934 440.398 784.157 440.398 L 785.351 433.232 L 781.768 432.037 L 780.574 432.037 L 781.768 433.232 L 782.962 438.009 C 774.602 440.398 767.436 441.592 761.464 446.37 L 750.715 442.787 L 748.326 451.147 L 745.938 452.341 L 739.966 453.536 L 736.383 458.313 L 732.8 457.119 L 731.606 461.896 L 732.8 461.896 L 738.772 463.09 L 738.772 464.285 L 731.606 464.285 L 731.606 465.479 C 729.617 465.071 727.626 464.673 725.634 464.285 L 724.44 405.762 L 728.023 402.179 L 743.549 391.43 C 751.91 384.264 755.493 374.709 759.076 365.154 L 761.464 355.6 C 761.464 350.822 759.076 344.851 765.047 341.267 L 763.853 337.684 L 762.659 331.713 L 767.436 331.713 L 759.076 312.603 L 761.464 310.215 L 751.91 297.077 L 751.91 295.882 L 741.16 271.996 L 736.383 268.413 L 731.606 270.801 L 735.189 264.83 L 720.857 266.024 L 719.662 260.052 L 693.387 267.218 L 693.387 269.607 L 686.221 268.413 L 676.666 274.384 C 670.694 276.773 664.723 277.967 663.528 285.133 L 658.751 286.328 L 659.945 289.911 L 648.002 307.826 L 646.807 314.992 C 646.807 319.769 644.419 326.935 646.807 328.13 C 652.779 331.713 649.196 336.49 649.196 337.684 L 652.779 344.851 C 655.168 350.822 658.751 356.794 664.723 359.183 L 664.723 360.377 L 665.917 361.571 L 667.111 369.932 C 670.694 380.681 677.86 390.235 687.415 395.013 C 700.553 400.985 701.747 410.539 700.553 421.288 L 700.553 528.779 M 769.825 436.815 L 771.019 438.009 L 771.019 436.815 L 769.825 436.815 M 655.168 354.405 L 653.973 353.211 L 655.168 354.405 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BED4D6",
    d: "M 781.768 432.037 L 785.351 433.232 L 784.157 440.398 C 788.934 440.398 796.1 438.009 796.1 446.37 C 797.294 446.37 796.1 446.37 796.1 446.37 L 793.711 451.147 L 793.711 452.341 L 792.517 453.536 L 791.323 454.73 L 790.128 454.73 L 791.323 455.924 C 786.545 467.868 781.768 478.617 779.379 491.755 C 776.991 501.309 776.991 512.058 775.796 521.613 L 774.602 529.973 L 729.217 532.362 C 726.828 532.362 724.44 532.362 725.634 527.585 L 725.634 464.285 L 731.606 467.868 C 731.605 467.071 731.605 466.275 731.606 465.479 L 731.606 464.285 L 738.772 464.285 L 738.772 463.09 C 736.39 462.649 734.001 462.251 731.606 461.896 L 732.8 457.119 L 736.383 458.313 L 736.383 459.507 L 737.577 459.507 L 736.383 458.313 L 739.966 453.536 L 745.938 452.341 L 748.326 451.147 L 750.715 442.787 L 761.464 446.37 C 767.436 441.592 774.602 440.398 782.962 438.009 L 781.768 433.232 L 781.768 432.037 M 778.185 445.175 L 778.185 441.592 L 776.991 441.592 C 777.391 442.786 777.789 443.98 778.185 445.175 M 742.355 455.924 L 744.743 455.924 L 742.355 455.924 M 781.768 441.592 Z M 804.461 436.815 L 803.266 430.843 L 796.1 439.204 L 793.711 436.815 L 804.461 422.483 L 797.294 422.483 L 799.683 416.511 C 800.878 412.928 805.655 409.345 808.044 410.539 C 812.821 412.928 814.015 411.734 814.015 405.762 L 817.598 409.345 L 817.598 410.539 C 822.376 411.734 822.376 411.734 819.987 416.511 L 817.598 421.288 L 804.461 436.815 M 809.238 416.511 L 806.849 417.705 L 810.432 420.094 L 815.21 420.094 C 816.404 415.317 812.821 416.511 809.238 416.511 M 814.015 414.122 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFDBDA",
    d: "M 794.906 451.147 L 796.1 446.37 L 794.906 451.147 Z M 791.323 455.924 L 790.128 454.73 L 791.323 454.73 L 791.323 455.924 Z M 792.517 453.536 L 793.711 452.341 L 792.517 453.536 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD2D6",
    d: "M 778.185 146.59 L 778.185 144.201 L 778.185 146.59 Z M 822.376 181.226 L 821.181 182.42 L 819.987 181.226 L 821.181 180.031 L 822.376 181.226 Z M 791.323 145.395 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBD3D6",
    d: "M 569.175 217.056 L 570.37 218.25 L 569.175 218.25 L 569.175 217.056 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD2D6",
    d: "M 661.14 121.509 L 662.334 120.314 L 662.334 122.703 L 661.14 121.509 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBD3D6",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD2D6",
    d: "M 818.793 178.837 Z M 626.504 145.395 C 626.504 145.395 627.698 145.395 626.504 145.395 Z M 778.185 143.007 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#357FA1",
    d: "M 725.634 469.062 L 725.634 527.585 L 724.44 524.002 L 718.468 527.585 L 722.051 529.973 L 722.051 531.168 L 700.553 528.779 L 700.553 421.288 C 701.747 410.539 700.553 400.985 687.415 395.013 C 677.86 390.235 670.694 380.681 667.111 369.932 L 665.917 361.571 L 664.723 360.377 L 664.723 357.988 C 665.917 349.628 665.917 340.073 669.5 332.907 C 675.472 316.186 687.415 304.243 696.97 289.911 C 707.719 276.773 723.245 277.967 732.8 292.299 L 753.104 325.741 C 756.687 332.907 757.881 340.073 759.076 347.239 L 759.076 363.96 C 755.493 374.709 751.91 384.264 743.549 391.43 L 728.023 402.179 L 724.44 405.762 L 725.634 464.285 L 725.634 469.062 M 690.998 359.183 C 693.387 369.932 699.358 375.903 707.719 379.486 C 710.108 380.681 713.691 381.875 714.885 380.681 C 736.383 371.126 738.772 347.239 730.411 332.907 L 712.496 312.603 L 695.775 332.907 C 689.804 341.267 688.609 349.628 690.998 359.183 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30799C",
    d: "M 655.168 576.553 C 658.751 572.97 656.362 570.581 653.973 568.192 L 659.945 568.192 L 661.14 570.581 L 661.14 568.192 L 668.306 568.192 C 669.5 571.775 670.694 574.164 669.5 576.553 L 669.5 580.136 L 670.694 580.136 C 670.694 575.358 675.472 571.775 670.694 568.192 L 676.666 568.192 L 676.666 572.97 L 677.86 572.97 L 677.86 568.192 L 686.221 568.192 L 686.221 569.387 L 680.249 569.387 L 681.443 576.553 L 675.472 583.719 L 677.86 584.913 L 624.115 584.913 C 625.309 582.525 620.532 578.941 626.504 577.747 C 625.309 586.108 631.281 581.33 634.864 582.525 L 634.864 578.941 L 640.836 584.913 L 640.836 578.941 L 643.224 582.525 L 650.39 577.747 L 646.807 571.775 L 655.168 576.553 C 658.751 578.941 658.751 578.941 659.945 575.358 L 655.168 576.553 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#276F92",
    d: "M 677.86 584.913 L 675.472 583.719 L 681.443 576.553 L 680.249 569.387 C 682.24 569.4 684.23 569.4 686.221 569.387 L 686.221 568.192 L 704.136 568.192 L 706.525 571.775 L 705.33 572.97 L 712.496 572.97 L 712.496 581.33 C 707.719 577.747 704.136 575.358 698.164 577.747 L 695.775 571.775 L 689.804 576.553 L 687.415 571.775 C 687.415 577.747 687.415 583.719 679.055 584.913 L 677.86 584.913 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#347EA0",
    d: "M 805.655 570.581 C 805.655 574.164 803.266 575.358 799.683 574.164 L 793.711 568.192 L 805.655 570.581 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#276F92",
    d: "M 670.694 568.192 C 675.472 571.775 670.694 575.358 670.694 580.136 L 669.5 580.136 L 669.5 576.553 C 670.694 574.164 669.5 571.775 668.306 568.192 L 670.694 568.192 Z M 677.86 568.192 L 677.86 572.97 L 676.666 572.97 L 676.666 568.192 L 677.86 568.192 Z M 661.14 568.192 L 661.14 570.581 L 659.945 568.192 L 661.14 568.192 Z M 716.079 568.192 L 716.079 569.387 L 716.079 568.192 C 714.885 568.192 716.079 568.192 716.079 568.192 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#357FA1",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBD3D6",
    d: "M 612.172 476.228 L 613.366 476.228 L 612.172 476.228 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8CBD3",
    d: "M 522.596 477.422 Z M 522.596 470.256 Z M 522.596 470.256 L 521.402 469.062 L 522.596 470.256 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#205978",
    d: "M 793.711 611.189 L 796.1 612.383 L 794.906 613.577 L 793.711 612.383 L 793.711 611.189 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8CBD3",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#357FA1",
    d: "M 799.683 574.164 L 794.906 581.33 L 793.711 575.358 L 790.128 576.553 L 790.128 575.358 L 794.906 571.775 L 799.683 574.164 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#276F92",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0EDDE",
    d: "M 759.076 365.154 L 759.076 347.239 C 757.881 340.073 756.687 332.907 753.104 325.741 L 732.8 292.299 C 723.245 277.967 707.719 276.773 696.97 289.911 C 687.415 304.243 675.472 316.186 669.5 332.907 C 665.917 340.073 665.917 349.628 664.723 357.988 C 658.751 356.794 655.168 350.822 652.779 344.851 L 649.196 337.684 C 649.196 336.49 652.779 331.713 646.807 328.13 C 644.419 326.935 646.807 319.769 646.807 314.992 L 648.002 307.826 L 659.945 289.911 L 658.751 286.328 L 663.528 285.133 C 664.723 277.967 670.694 276.773 676.666 274.384 L 686.221 268.413 L 693.387 269.607 L 693.387 267.218 L 719.662 260.052 L 720.857 266.024 L 735.189 264.83 L 731.606 270.801 L 736.383 268.413 L 741.16 271.996 L 751.91 295.882 L 751.91 297.077 L 761.464 310.215 L 759.076 312.603 L 767.436 331.713 L 762.659 331.713 L 763.853 337.684 L 765.047 341.267 C 759.076 344.851 761.464 350.822 761.464 355.6 L 759.076 365.154 M 747.132 291.105 L 747.132 289.911 L 745.938 289.911 L 745.938 293.494 L 747.132 292.299 L 747.132 291.105 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BED4D6",
    d: "M 769.825 436.815 L 771.019 436.815 L 771.019 438.009 L 769.825 436.815 Z M 781.768 432.037 L 780.574 432.037 L 781.768 432.037 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0EDDE",
    d: "M 664.723 360.377 C 664.723 360.377 664.723 361.571 664.723 360.377 C 664.723 360.377 664.723 361.571 664.723 360.377 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BED4D6",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFDBDA",
    d: "M 778.185 446.37 L 776.991 447.564 C 777.395 445.575 777.793 443.584 778.185 441.592 L 778.185 446.37 Z M 743.549 455.924 L 744.743 455.924 L 743.549 455.924 Z M 791.323 448.758 Z M 736.383 458.313 L 737.577 459.507 L 736.383 459.507 L 736.383 458.313 Z M 725.634 469.062 L 725.634 466.673 L 725.634 469.062 Z M 782.962 446.37 Z M 781.768 441.592 Z M 810.432 416.511 C 812.821 416.511 816.404 415.317 815.21 420.094 L 810.432 420.094 L 806.849 417.705 L 810.432 416.511 Z M 814.015 414.122 Z M 817.598 410.539 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1EDDE",
    d: "M 690.998 359.183 C 688.609 349.628 689.804 341.267 695.775 332.907 L 712.496 312.603 L 730.411 332.907 C 738.772 347.239 736.383 371.126 714.885 380.681 C 713.691 381.875 710.108 380.681 707.719 379.486 C 699.358 375.903 693.387 369.932 690.998 359.183 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#276F92",
    d: "M 655.168 576.553 L 659.945 575.358 C 658.751 578.941 658.751 578.941 656.362 576.553 L 655.168 576.553 Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFDBDA",
    d: "M 747.132 291.105 L 747.132 292.299 L 745.938 293.494 L 745.938 289.911 L 747.132 289.911 L 747.132 291.105 Z",
    style: {
      strokeWidth: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspirationSmall);
export default __webpack_public_path__ + "static/media/inspiration_small.de334514fc431232554301cf69b7089f.svg";
export { ForwardRef as ReactComponent };